import { render, staticRenderFns } from "./specialities.vue?vue&type=template&id=fc547e02&scoped=true&"
import script from "./specialities.vue?vue&type=script&lang=js&"
export * from "./specialities.vue?vue&type=script&lang=js&"
import style0 from "./specialities.vue?vue&type=style&index=0&id=fc547e02&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc547e02",
  null
  
)

export default component.exports